import { render, staticRenderFns } from "./ProductTraceabilityTab.vue?vue&type=template&id=c76c6e46&scoped=true&"
import script from "./ProductTraceabilityTab.vue?vue&type=script&lang=js&"
export * from "./ProductTraceabilityTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c76c6e46",
  null
  
)

export default component.exports